import React, { forwardRef } from 'react';
import { Button, ButtonProps } from '@mui/material';

export interface BannerDismissButtonProps extends ButtonProps {}

/**
 * BannerDismissButton is a proxy component to <Button variant="text" color="secondary" size="small" />
 */
export const BannerDismissButton: React.FC<BannerDismissButtonProps> = forwardRef((props, ref) => {
  return <Button ref={ref} variant="text" color="secondary" size="small" {...props} />;
});
